/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Community_TitleInputs */

const en_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Growing the game.`)
};

const es_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haciendo crecer el golf.`)
};

const de_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Spiel wachsen lassen.`)
};

const zh_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推广高尔夫运动。`)
};

const ar_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنمية اللعبة.`)
};

const fr_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire grandir le jeu.`)
};

const vi_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát triển môn chơi.`)
};

const sw_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kukuza mchezo.`)
};

const th_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขยายวงการกอล์ฟ`)
};

const bs_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razvijamo igru.`)
};

const ja_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゴルフの裾野を広げる。`)
};

const ko_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`골프의 저변을 넓힙니다.`)
};

const pt_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazendo o golfe crescer.`)
};

const it_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Far crescere il golf.`)
};

const sv_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi utvecklar spelet.`)
};

const nl_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De sport laten groeien.`)
};

const da_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi udvikler spillet.`)
};

const nb_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi utvikler spillet.`)
};

const fi_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasvatamme lajia.`)
};

const pl_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozwijamy golfa.`)
};

const ru_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Развиваем гольф.`)
};

const tr_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfü büyütüyoruz.`)
};

const hi_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खेल को आगे बढ़ाना।`)
};

const id_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menumbuhkan golf.`)
};

const ms_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memajukan sukan golf.`)
};

const cs_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozvíjíme golf.`)
};

const el_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αναπτύσσουμε το άθλημα.`)
};

const he_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מצמיחים את המשחק.`)
};

const af_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ons laat die spel groei.`)
};

const hu_range_community_title = /** @type {(inputs: Range_Community_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A golf népszerűsítése.`)
};

/**
* | output |
* | --- |
* | "Growing the game." |
*
* @param {Range_Community_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_community_title = /** @type {((inputs?: Range_Community_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Community_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_community_title(inputs)
	if (locale === "de") return de_range_community_title(inputs)
	if (locale === "zh") return zh_range_community_title(inputs)
	if (locale === "ar") return ar_range_community_title(inputs)
	if (locale === "fr") return fr_range_community_title(inputs)
	if (locale === "vi") return vi_range_community_title(inputs)
	if (locale === "sw") return sw_range_community_title(inputs)
	if (locale === "th") return th_range_community_title(inputs)
	if (locale === "bs") return bs_range_community_title(inputs)
	if (locale === "ja") return ja_range_community_title(inputs)
	if (locale === "ko") return ko_range_community_title(inputs)
	if (locale === "pt") return pt_range_community_title(inputs)
	if (locale === "it") return it_range_community_title(inputs)
	if (locale === "sv") return sv_range_community_title(inputs)
	if (locale === "nl") return nl_range_community_title(inputs)
	if (locale === "da") return da_range_community_title(inputs)
	if (locale === "nb") return nb_range_community_title(inputs)
	if (locale === "fi") return fi_range_community_title(inputs)
	if (locale === "pl") return pl_range_community_title(inputs)
	if (locale === "ru") return ru_range_community_title(inputs)
	if (locale === "tr") return tr_range_community_title(inputs)
	if (locale === "hi") return hi_range_community_title(inputs)
	if (locale === "id") return id_range_community_title(inputs)
	if (locale === "ms") return ms_range_community_title(inputs)
	if (locale === "cs") return cs_range_community_title(inputs)
	if (locale === "el") return el_range_community_title(inputs)
	if (locale === "he") return he_range_community_title(inputs)
	if (locale === "af") return af_range_community_title(inputs)
	if (locale === "hu") return hu_range_community_title(inputs)
	return en_range_community_title(inputs)
});